import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Solution } from './components/sections/Solution';
import { WhatsInside } from './components/sections/WhatsInside';
import { WhoIsThisFor } from './components/sections/WhoIsThisFor';
import { Comparison } from './components/sections/Comparison';
import { Testimonials } from './components/sections/Testimonials';
import { Pricing } from './components/sections/Pricing';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalNudge } from './components/sections/FinalNudge';
import { Footer } from './components/sections/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { QuizFunnel } from './pages/QuizFunnel';
import { AnimatedQuizFunnel } from './pages/AnimatedQuizFunnel';
function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-stone-900 selection:bg-amber-200 selection:text-amber-900" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <Solution data-id="element-4" />
        <WhatsInside data-id="element-5" />
        <WhoIsThisFor data-id="element-6" />
        <Comparison data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Pricing data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalNudge data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <RecentPurchaseToast data-id="element-14" />
    </div>;
}
export function App() {
  return <Routes data-id="element-15">
      <Route path="/" element={<HomePage data-id="element-17" />} data-id="element-16" />
      <Route path="/quiz" element={<QuizFunnel data-id="element-19" />} data-id="element-18" />
      <Route path="/quiz-2" element={<AnimatedQuizFunnel data-id="element-21" />} data-id="element-20" />
    </Routes>;
}